import ChangeEventType from '@/features/change-event-type';
import { DraggableModalWrapper } from '@/shared/ui';
import AddNewEvent from './addNewEvent';
import ChangeEventDuration from './changeEventDuration';
import NewEvents from './newEvents';
import useRhythmEventsModal from './useRhythmEventsModal';

/**
 * Renders the draggable modals owned by the rhythm events tab: add new event, new events, bulk change event type and the two change-duration flows. Reads the controlModal flags plus study, profile, timezone and ECG context from useRhythmEventsModal to toggle each wrapper and wire its cancel handler back to the store.
 *
 * @returns The set of draggable modal wrappers for the rhythm events tab, each shown only when its control flag is set.
 */
const RhythmEventsModal = () => {
  const {
    keyRecoil,
    controlModal,
    selectedStrip,
    selectedMultipleStrip,
    selectedEvent,
    studyId,
    profileId,
    timezone,
    startReport,
    timezoneOffset,
    stopReport,
    ecgDataMap,
    onClickCancelAddNewEvent,
    onClickCancelNewEvents,
    onClickCancelChangeEventTypeBulk,
    onClickCancelChangeEventDurationButtonType,
    onClickCancelChangeEventDurationSelectedInfo,
  } = useRhythmEventsModal();

  return (
    <>
      {/* Button Add new event */}
      <DraggableModalWrapper visible={controlModal.isShowAddNewEvent} ariaLabel="Add new event">
        <AddNewEvent
          onCancel={onClickCancelAddNewEvent}
          timezone={timezone}
          timezoneOffset={timezoneOffset}
          ecgDataMap={ecgDataMap}
          studyId={studyId}
          profileId={profileId}
          startReport={startReport}
          stopReport={stopReport}
        />
      </DraggableModalWrapper>
      <DraggableModalWrapper visible={controlModal.isShowNewEvents} ariaLabel="New events">
        <NewEvents
          onCancel={onClickCancelNewEvents}
          timezoneOffset={timezoneOffset}
          ecgDataMap={ecgDataMap}
          startReport={startReport}
        />
      </DraggableModalWrapper>
      {/* Button Add new event */}
      {/* Button Type */}
      <DraggableModalWrapper
        visible={controlModal.isShowChangeTypeBulk}
        ariaLabel="Change event type"
      >
        <ChangeEventType
          keyRecoil={keyRecoil}
          onCancel={onClickCancelChangeEventTypeBulk}
          ecgDataMap={ecgDataMap}
          studyId={studyId}
          profileId={profileId}
          selectedStrip={selectedStrip}
          selectedMultipleStrip={selectedMultipleStrip}
        />
      </DraggableModalWrapper>
      <DraggableModalWrapper
        visible={controlModal.isShowChangeDurationButtonType}
        ariaLabel="Change event duration"
      >
        <ChangeEventDuration
          onCancel={onClickCancelChangeEventDurationButtonType}
          selectedEvent={selectedStrip}
          timezone={timezone}
          timezoneOffset={timezoneOffset}
          ecgDataMap={ecgDataMap}
          studyId={studyId}
          profileId={profileId}
        />
      </DraggableModalWrapper>
      {/* Button Type */}
      {/* Selected info option */}
      <DraggableModalWrapper
        visible={controlModal.isShowChangeDurationSelectedInfo}
        ariaLabel="Change event duration"
      >
        <ChangeEventDuration
          onCancel={onClickCancelChangeEventDurationSelectedInfo}
          timezone={timezone}
          timezoneOffset={timezoneOffset}
          ecgDataMap={ecgDataMap}
          studyId={studyId}
          profileId={profileId}
          selectedEvent={selectedEvent}
        />
      </DraggableModalWrapper>
      {/* <DraggableModalWrapper
        visible={controlModal.isShowChangeTypeSingle}
      >
        <ChangeEventType
          keyRecoil={keyRecoil}
          onCancel={onClickCancelChangeEventTypeSingle}
          selectedStrip={selectedEvent}
          selectedMultipleStrip={[]}
        />
      </DraggableModalWrapper> */}
      {/* <DraggableModalWrapper
        visible={controlModal.isShowIncludedStrips}
      >
        <IncludedStrips
          onClickClose={onClickCancelIncludedStrips}
          samplingFrequency={ecgDataMap?.samplingFrequency}
          timezoneOffset={timezoneOffset}
        />
      </DraggableModalWrapper> */}
      {/* Selected info option */}
    </>
  );
};

export default RhythmEventsModal;
